export const business = {
    name: "Rose Cafe | קפה רוז",
    description: "בית קפה, גלידריה וקינוחים"
}

export const contact = {
    name: "Cafe Rose",
    phone: "046719669",
    email: "Shimaajandawe31@gmail.com",
    website: "https://rosecafe.qbmedia.co.il",
    menu:"http://menu-rosecafe.qbmedia.co.il",
    waze: "https://waze.com/ul/hsvc41wdby",
    saveBtnText: "הוסף לאנשי קשר",
    orderNowText: "הזמן השירות עכשיו"
};

export const socialAccounts = {
    wsp:"https://api.whatsapp.com/send?phone=972525040074",
    ig:"http://instagram.com/rose.cafe6",
    fb:"https://facebook.com/Rose.cafe6",
}

export const socialBtns = {
    menu: "תפריט",
    callIcon: "חייג",
    wspIcon: "ואטסאפ",
    igIcon: "אינסטה",
    fbIcon: "פייסבוק",
    mail: "אימייל",
    review: "דרגו אותנו",
    waze: "בואו אלינו"
}

export const schedule = {
    link:"https://.com",
    title:"קביעת פגישה אונליין",
}

export const footer = {
    desclaimer: "נבנה ע״י",
    copywrites: "קיובי מדיה"
}